import { messageError } from '../../components/message';
import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse, IAPIresponseTask } from '../../model';
import {
  IGameEnvCreate,
  IEnvService,
  IGameEnvModel,
  IApiGameEnvCollectionRes,
  IGameEnvSync,
  IEnvExportParams,
  IEnvImportCheckParams,
  IEnvImportCheck,
  IUpdateEnvBody,
  ITimeSettingBody,
} from '../../model/api-modules/env';
import { initGameEnvFailedTip } from '../../pages/game-content/lib';
import { filterCurAreaEnvList } from '../../pages/utils/env';

import {
  API_PREFIX,
  INGAME_CONSOLE_PROXY_PREFIX,
  INGAME_CONSOLE_PROXY_PREFIX_GAME,
} from '../config';

// 获取游戏环境列表
export const fetchEnvList = (gameID: string, isCurRegion?: boolean) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/games/${gameID}/env/list`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IGameEnvModel[]>(response, 'data');

      const envs = isCurRegion ? filterCurAreaEnvList(res) : res;
      return envs;
    } catch (error) {
      console.log('failed: fetchEnvList', error);
      initGameEnvFailedTip(gameID, null);
      return null;
    }
  });

// 获取游戏环境列表集合
export const fetchEnvCollectionList = (studioID: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/games/game-env-collection?studioID=${studioID}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IApiGameEnvCollectionRes[]>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      console.log('failed: fetchEnvCollectionList', error);
      return null;
    }
  });

// 删除游戏环境
export const removeEnv = (id: number, body: IEnvService) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/games/${body.gameID}/env/${id}`;
      const response = await api.commonRequest('DELETE', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed: removeEnv', error);
      if (error instanceof APIError) {
        messageError(error?.apiError?.message);
        return null;
      }
      return {};
    }
  });
// 创建游戏环境
export const addEnv = (gameID: string, body: IGameEnvCreate, toLink: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/games/${gameID}/env?toLink=${encodeURIComponent(
        toLink
      )}`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IGameEnvModel>(response, 'data');
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  });
// 修改游戏环境
export const updateEnv = (
  gameID: string,
  envID: number,
  body: IUpdateEnvBody
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/games/${gameID}/env/${envID}`;
      const response = await api.commonRequest('PATCH', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  });
// 同步游戏环境
export const syncEnv = (body: IGameEnvSync) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/games/${body.gameID}/env/${body.sourceEnvID}/sync/${body.targetEnvID}`;
      // ServiceIds:源环境的服务 id
      const response = await api.commonRequest('POST', url, {
        // ServiceIds: body.ServiceIds,
        force: body.force,
        transparentData: body.transparentData,
      });
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (err: any) {
      console.error(err);
      throw err;
    }
  });
// 获取游戏环境同步状态
export const getSyncStatus = (gameID: string, taskID: number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/games/${gameID}/env/sync-status/${taskID}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IAPIresponseTask>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed: getSyncStatus', error);
      throw error;
    }
  });

// 获取配置
export const getDictionaryConfig = (key: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/dictionary/config?key=${key}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<any>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed: getDictionaryConfig', error);
      throw error;
    }
  });

// 环境导出
export const envExport = (body: IEnvExportParams) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${INGAME_CONSOLE_PROXY_PREFIX}/v1/api/k8s/ingame/game_service_env/create_game_env_export_task`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed:', error);
      if (error instanceof APIError) {
        return null;
      }
      return {};
    }
  });

// 环境导入文件检查
export const envImportCheck = (body: IEnvImportCheckParams) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${INGAME_CONSOLE_PROXY_PREFIX}/v1/api/k8s/ingame/game_service_env/parse_game_env_import_info`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IEnvImportCheck>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed:', error);
      if (error instanceof APIError) {
        return null;
      }
      return null;
    }
  });

// 环境导入
export const envImport = (body: IEnvImportCheckParams) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${INGAME_CONSOLE_PROXY_PREFIX}/v1/api/k8s/ingame/game_service_env/create_game_env_import_task`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IEnvImportCheck>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed:', error);
      if (error instanceof APIError) {
        return null;
      }
      return null;
    }
  });

// 时区设置-七彩石
export const saveTimeSetting = (body: ITimeSettingBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${INGAME_CONSOLE_PROXY_PREFIX_GAME}/v1/api/k8s/ingame/game_service_env/frequency_definition`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error: any) {
      console.log('failed:', error);
      if (error instanceof APIError) {
        return null;
      }
      return null;
    }
  });
